export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/account/login', '/accounts/recover_password', '[action="/account/recover"]', {
      before: true,
      params: ['message']
    });
  });
}
